import { FC, useCallback, useEffect, useState } from 'react';
import { PlayFolder } from '../../types';
import { useStore } from '@nanostores/react';
import {
  $playFolderAssignModalIsOpen,
  $playFolders,
  $playFoldersIsLoading,
  getFolders,
} from '../../store/playFolders';
import { Modal } from 'antd';
import { lighterBlueBackground, yellow } from '../colors';
import { Button } from '../../ui/Button';
import { XMarkIcon } from "@heroicons/react/24/outline"
import { useAuthContext } from '../../AuthProvider';
import { savePlay } from '../../store/plays';

export const AssignFolderModal: FC = () => {
  const modalStore = useStore($playFolderAssignModalIsOpen)
  const [isOpen, setIsOpen] = useState<boolean>(false)

  useEffect(() => {
    setIsOpen(modalStore.isOpen)
  }, [modalStore]);

  if (!isOpen) return null
  return <AssignFolderModalContent />
}

export const AssignFolderModalContent: FC = () => {
  const modalStore = useStore($playFolderAssignModalIsOpen)
  const isFoldersLoading = useStore($playFoldersIsLoading)
  const foldersStore = useStore($playFolders)
  const [currentFolders, setCurrentFolders] = useState<PlayFolder[]>([])
  const [isOpen, setIsOpen] = useState<boolean>(true)

  const [saveIsLoading, setSaveIsLoading] = useState<boolean>(false)

  useEffect(() => {
    const loadFolders = async () => {
      await getFolders()
    }

    void loadFolders()
  }, []);

  const defaultFolder: PlayFolder = { id: 'default', name: 'Default', description: 'Default folder' }

  useEffect(() => {
    setCurrentFolders([defaultFolder, ...foldersStore])
  }, [foldersStore]);

  const { isPro, isAdmin, data: { licenseGroup } = {} } = useAuthContext()

  const onSelect = useCallback(async ( folder: PlayFolder) => {
    if (!modalStore.play) return
    setSaveIsLoading(true)
    savePlay({
      id: modalStore.play.id,
      name: modalStore.play.name,
      snapshots: modalStore.play.snapshots,
      namings: modalStore.play.namings,
      category: 'Custom',
      synced: false,
      isDraft: false,
      folderId: folder.id === 'default' ? null : folder.id,
      licenseGroup
    })
    setSaveIsLoading(false)
    $playFolderAssignModalIsOpen.set({ isOpen: false, play: null });
  }, [modalStore, setSaveIsLoading, licenseGroup])

  return (
    <Modal
      open={isOpen}
      centered={true}
      closable={true}
      closeIcon={<div style={{ color: yellow}}><XMarkIcon style={{ width: '34px'}} /></div>}
      onCancel={() => {
        setIsOpen(false)
      }}
      afterClose={() => {
        $playFolderAssignModalIsOpen.set({ isOpen: false, play: null })
      }}
      footer={null}
      styles={{
        header: {
          background: lighterBlueBackground,
          fontSize: '30px !important',
          color: '#fff'
        },
        content: {
          background: lighterBlueBackground,
          color: '#fff'
        }
      }}
    >
      <div>
        <div style={{ marginTop: '10px' }}>
          <h2 style={{ color: '#fff', textAlign: 'center', marginBottom: '20px' }}>Move <span style={{ color: yellow }}>{modalStore.play?.name}</span> play to folder</h2>
        </div>
        <div>
          {/*{isError && (*/}
          {/*  <div style={{ color: 'red', marginBottom: '10px', textAlign: 'center' }}>*/}
          {/*    An error occurred while assigning the folder. Please try again.*/}
          {/*  </div>*/}
          {/*)}*/}
          {currentFolders.length === 0 && <div style={{ color: '#fff', textAlign: 'center' }}>No folders available</div>}
          {currentFolders.length > 0 && currentFolders.map(folder => (
            <div key={folder.id} style={{ userSelect: 'none', marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '1.1rem', textTransform: 'uppercase', borderBottom: '1px solid rgba(255,255,255,0.3)' }}>
              <span style={{ fontWeight: 'bold' }}>{folder.name}</span>
              <Button disabled={saveIsLoading || modalStore.play?.folderId === folder.id || (folder.id === 'default' && !modalStore.play?.folderId)} onClick={() => void onSelect(folder)}>Select</Button>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}